import { Action, Module, Mutation } from "vuex-class-modules"

import { AIConfigProvider, AIModel, AIModelPayload, AIModelStatusPayload } from "@/models"
import { BaseModule } from "@/models/BaseModule"
import { apiService } from "@/services/api.service"
import { Endpoint } from "@/services/endpoints"

import { Modules } from "../modules"
import { store } from "../store"

export enum AIModelsActions {
  GET_AI_MODELS = "GET_AI_MODELS",
  GET_AI_MODEL_PROVIDERS = "GET_AI_MODEL_PROVIDERS",
  CREATE_AI_MODEL = "CREATE_AI_MODEL",
  DELETE_AI_MODEL = "DELETE_AI_MODEL",
  UPDATE_AI_MODEL_STATUS = "UPDATE_AI_MODEL_STATUS"
}

@Module
class AIModelsModule extends BaseModule {
  models: AIModel[] = []
  providers: AIConfigProvider[] = []

  @Mutation
  setModels(models: AIModel[]) {
    this.models = models
  }

  @Mutation
  setProviders(providers: AIConfigProvider[]) {
    this.providers = providers
  }

  @Action
  async [AIModelsActions.GET_AI_MODELS]() {
    const data = await apiService.get<AIModel[]>(Endpoint.GET_AI_MODELS())

    return this.handleResponse<AIModel[]>(data, models => {
      this.setModels(models)
      return models
    })
  }

  @Action
  async [AIModelsActions.GET_AI_MODEL_PROVIDERS]() {
    const data = await apiService.get<AIConfigProvider[]>(Endpoint.GET_AI_MODEL_PROVIDERS())

    return this.handleResponse<AIConfigProvider[]>(data, providers => {
      const providerModels = providers.map(provider => new AIConfigProvider(provider))

      this.setProviders(providerModels)
      return providerModels
    })
  }

  @Action
  async [AIModelsActions.CREATE_AI_MODEL](payload: AIModelPayload) {
    const data = await apiService.post<AIModel>(Endpoint.CREATE_AI_MODEL(), payload)

    return this.handleResponse<AIModel>(data, async () => {
      await this[AIModelsActions.GET_AI_MODELS]()
      return true
    })
  }

  @Action
  async [AIModelsActions.DELETE_AI_MODEL](modelId: string) {
    const data = await apiService.delete<void>(Endpoint.DELETE_AI_MODEL(modelId))

    return this.handleResponse<void>(data, async () => {
      await this[AIModelsActions.GET_AI_MODELS]()
      return true
    })
  }

  @Action
  async [AIModelsActions.UPDATE_AI_MODEL_STATUS](payload: AIModelStatusPayload) {
    const data = await apiService.patch<void>(
      Endpoint.UPDATE_AI_MODEL_STATUS(payload.modelId),
      payload.enabled
    )

    return this.handleResponse<void>(data, async () => {
      await this[AIModelsActions.GET_AI_MODELS]()
      return true
    })
  }
}

export const aiModelsModule = new AIModelsModule({
  store,
  name: Modules.AI_MODELS
})
